import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {RouterService} from '@npck/libs/commons';
import {SnackbarService} from '@npck/libs/ui-kit';
import {Path} from '../../../path';
import {KnowledgeBaseTab} from '../knowledge-base.component';

// Macos Cmd+Shift+3/4/5 covered by event.metaKey
const SCREENSHOT_KEYS = ['PrintScreen', 'F11', 'F13', 'F14', 'F15', 'F16', 'F17', 'F18', 'F19', 'F20'];
const REVEAL_DELAY_SECONDS = 0;

@Component({
    selector: 'af-knowledge-base-document-view',
    standalone: false,
    templateUrl: './knowledge-base-document-view.component.html',
    styleUrl: './knowledge-base-document-view.component.scss',
})
export class KnowledgeBaseDocumentViewComponent implements OnInit, OnDestroy {
    src: string | undefined;
    documentName: string | undefined;
    isVisible = true;
    countdown = 0;
    tabPathToTab: Record<string, KnowledgeBaseTab> = {[Path.DOCUMENTS]: 'tabDocuments'};

    private countdownTimer: ReturnType<typeof setInterval> | undefined;

    constructor(
        private routerService: RouterService,
        private snackbarService: SnackbarService,
    ) {
    }

    @HostListener('document:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (event.metaKey) {
            event.preventDefault();
            this.hideViewer();
            this.snackbarService.showSnackBar('i18n_af_screenshotForbidden', 'error');
        } else if (SCREENSHOT_KEYS.includes(event.key)) {
            event.preventDefault();
            this.snackbarService.showSnackBar('i18n_af_screenshotForbidden', 'error');
        }
    }

    @HostListener('window:blur')
    onWindowBlur(): void {
        this.hideViewer();
    }

    @HostListener('window:focus')
    onWindowFocus(): void {
        this.startCountdown();
    }

    @HostListener('document:visibilitychange')
    onVisibilityChange(): void {
        if (document.hidden) {
            this.hideViewer();
        } else {
            this.startCountdown();
        }
    }

    breadcrumbCustomizer = (path: string): string => {
        if (path === Path.VIEW_DOCUMENT) {
            return this.documentName;
        }
        return path;
    };

    specialFilter = (path: string): boolean => {
        return path === Path.VIEW_DOCUMENT;
    };

    unloadHandler = (): void => {
        URL.revokeObjectURL(this.src!);
    };

    ngOnInit(): void {
        this.src = this.routerService.getState<string>('blobUrl');
        this.documentName = this.routerService.getState<string>('documentName');
        window.addEventListener('beforeunload', this.unloadHandler);
    }

    ngOnDestroy(): void {
        window.removeEventListener('beforeunload', this.unloadHandler);
        this.clearCountdown();
        if (this.src) {
            URL.revokeObjectURL(this.src);
        }
    }

    private hideViewer(): void {
        this.isVisible = false;
        this.clearCountdown();
    }

    private startCountdown(): void {
        this.clearCountdown();
        this.countdown = REVEAL_DELAY_SECONDS;
        this.countdownTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
                this.clearCountdown();
                this.isVisible = true;
            }
        }, 1000);
    }

    private clearCountdown(): void {
        if (this.countdownTimer !== undefined) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = undefined;
        }
        this.countdown = 0;
    }
}
